import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Send } from "lucide-react";

const CTA = () => {
  return (
    <section className="section-padding relative overflow-hidden">
      {/* Background neon glows */}
      <div
        className="absolute bottom-[-100px] left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full opacity-[0.18] blur-[120px] pointer-events-none"
        style={{
          background: "radial-gradient(circle, #7C4DFF, #27B8FF)",
        }}
      />
      <div className="absolute inset-0 tech-grid opacity-10 pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[32px] p-8 sm:p-16 overflow-hidden"
          style={{
            background: "linear-gradient(135deg, rgba(15, 22, 48, 0.9), rgba(11, 18, 37, 0.85))",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            boxShadow: "0 24px 80px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.02)",
          }}
        >
          {/* Decorative shapes */}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_left,rgba(124,77,255,0.1),transparent_35%)] pointer-events-none" />
          <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_bottom_right,rgba(39,184,255,0.1),transparent_35%)] pointer-events-none" />

          <div className="relative z-10 max-w-3xl mx-auto">
            {/* Badge */}
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#7C4DFF]/10 border border-[#7C4DFF]/20 text-ai-glow text-sm font-semibold tracking-wider uppercase mb-6">
              <Sparkles className="w-4 h-4 text-[#27B8FF]" />
              Let's Build Together
            </span>

            {/* Heading */}
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6 leading-tight"
              style={{ fontFamily: '"Space Grotesk", sans-serif' }}
            >
              Ready to Transform Your Business with{" "}
              <span className="gradient-text">AI</span>?
            </h2>

            {/* Description */}
            <p className="text-base sm:text-lg text-slate-400 mb-10 leading-relaxed max-w-2xl mx-auto">
              Partner with CLIENTCODEAI to build intelligent, secure, and scalable software solutions.
              Whether you are an enterprise, a startup, a college, or a government organization,
              we turn your boldest ideas into reality.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/contact"
                className="relative inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-white text-sm shadow-[0_0_35px_rgba(124,77,255,0.45)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_50px_rgba(124,77,255,0.65)] group overflow-hidden"
                style={{
                  background: "linear-gradient(135deg, #7C4DFF, #9F67FF)",
                }}
              >
                <span className="relative z-10 flex items-center gap-2">
                  Start Your Project
                  <Send className="w-4 h-4" />
                </span>
                <span className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </Link>

              <Link
                to="/projects"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-[#27B8FF] text-sm bg-cyan-400/5 border border-cyan-400/20 transition-all duration-300 hover:bg-cyan-400/10 hover:border-cyan-400/40 hover:scale-105"
              >
                View Our Work
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
